export default [
    {
      path: '/plans/wash/list',
      name: 'plans.wash.list',
      component: () => import('@/views/modules/plans/wash-plan/plan-list/PlansList'),
      meta: {
        module: 'plans.wash',
        pageTitle: 'List of wash Plans',
        breadcrumb: [
        // { text: 'List wash Plans', active: true, },
          //{ text: 'Create Plan', to: {name: 'plans.rain.create'} }
        ],
      }
    },
  
  
    {
      path: '/plans/wash/create',
      name: 'plans.wash.create',
      component: () => import('@/views/modules/plans/wash-plan/create/CreateWashPlan'),
      meta: {
        module: 'plans.wash',
        pageTitle: 'Plan Create',
        breadcrumb: [
          { text: 'List Plans', to: {name: 'plans.wash.list'} },
          { text: 'Plan Create' , active: true}
        ],
      }
    },
  
  
    {
      path: '/plans/wash/:id/edit',
      name: 'plans.wash.edit',
      component: () => import('@/views/modules/plans/wash-plan/edit/EditWashPlan'),
      meta: {
        module: 'plans.wash',
        pageTitle: 'Wash Plan Edit',
        breadcrumb: [
          { text: 'List Plans', to: {name: 'plans.wash.list'} },
          { text: 'Edit Plan' , to: {name: 'plans.wash.edit'}},
         
        ],
      }
    },
  ]
  